import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BsCheckCircle } from "react-icons/bs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { Icon, Infinity } from "lucide-react";

export default function CustomPricing() {
  const [isMonthly, setIsMonthly] = useState(true);
  const [planType, setPlanType] = useState("user");
  const userServicesData = [
    {
      icon: Infinity,
      title1: "Everything in",
      // para: "Pro",
      para: "Starter",
      title2: "Notes Collaboration",
      title3: "Office Hub, Bill Flow and Bulk Uploads",
      title4: "1 GB Storage",
    },
    {
      icon: Infinity,
      title1: "Everything in",
      // para: "Elite",
      para: "Pro",
      title2: "Checklists in Tasks (SOPs)",
      title3: "Maker-Checker (Teams Control), Logs",
      title4: "1.5 GB Storage + Priority Support",
    },
  ];
  const [planData, setPlanData] = useState(userServicesData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [opentab, setOpenTab] = useState(0);

  const [tabLoading, setTabLoading] = useState(false);

  // Data for Team Plans
  const teamServicesData = [
    {
      icon: Infinity,
      userCount: "10 Users",
      title1: "Everything in",
      // para: "Pro",
      para: "Starter",
      title2: "Collaborative Notes and Teamwork",
      title3: "Office Hub, Bill Flow and Bulk Uploads",
      title4: "3 GB Storage",
    },
    {
      icon: Infinity,
      userCount: "For 10+ users (Custom)",
      title1: "Everything in",
      // para: "Elite",
      para: "Pro",
      title2: "SOP-based Task Checklists",
      title3: "Maker-Checker Controls and Logs",
      title4: "5 GB Storage + Priority Support",
    },
  ];
  const baseUrl = "https://admin.simplifyte.com/api";
  // const baseUrl = "http://192.168.0.139:8000/api"

  const handleToggle = () => {
    // Only allow toggle for User mode
    if (planType === "user") {
      setIsMonthly((prev) => !prev);
    }
    // console.log("aause che", planType);
  };

  const handlePlanTypeChange = (type) => {
    setPlanType(type);
    // Reset to monthly when switching to user mode
    if (type === "user") {
      setIsMonthly(true);
    }
  };
  const HandleTabClick = (tabActive) => {
    setOpenTab(tabActive);
    setPlanType(tabActive === 0 ? "user" : "team");
    setTabLoading(true);
  };
  const formatFeature = (f) => {
    if (f.pivot.status === "included") {
      return f.name;
    } else {
      let limitText = f.formatted_limit;
      if (typeof limitText === "number" && f.code === "page_history") {
        limitText = `${limitText} day`;
      } else if (limitText === "unlimited" || f.pivot.status === "unlimited") {
        limitText = "Unlimited";
      }
      const itemName = f.name.replace(/^Maximum /i, "").toLowerCase();
      return `${limitText} ${itemName}`;
    }
  };

  useEffect(() => {
    setTabLoading(true);
    axios
      .get(`${baseUrl}/plans-website?type=${planType}`)
      .then((response) => {
        const data = response.data?.data?.[planType] || [];
        const targetFree = planType === "user" ? "Free User" : "Free";
        const targetStarter = planType === "user" ? "Starter User" : "Starter";
        const targetPro = planType === "user" ? "Pro User" : "Pro";
        const targetElite = planType === "user" ? "Elite User" : "Elite";

        const freePlan = data.find((plan) => plan.name === targetFree);
        const starterPlan = data.find((plan) => plan.name === targetStarter);
        const proPlan = data.find((plan) => plan.name === targetPro);
        const elitePlan = data.find((plan) => plan.name === targetElite);

        const apiPlans = [proPlan, elitePlan].filter(Boolean);

        if (apiPlans.length > 0) {
          const formattedPlans = apiPlans.map((plan) => {
            const isPro = plan.name === targetPro;
            const comparePlan = isPro ? starterPlan : proPlan;

            let features = [];
            if (isPro) {
              features.push("All Starter Features +");
            } else {
              features.push("All Pro Features +");
            }

            if (comparePlan) {
              const mapCompare = new Map();
              comparePlan.features.forEach((f) => {
                mapCompare.set(f.code, {
                  status: f.pivot.status,
                  limit_value: f.pivot.limit_value,
                });
              });

              plan.features.forEach((f) => {
                const comp = mapCompare.get(f.code);
                if (
                  !comp ||
                  comp.status !== f.pivot.status ||
                  comp.limit_value !== f.pivot.limit_value
                ) {
                  features.push(formatFeature(f));
                }
              });
            } else {
              features = features.concat(
                plan.features.map((f) => formatFeature(f)),
              );
            }

            // Special case for team Pro: add included users
            if (planType === "team" && isPro) {
              const usersCount = plan.included_users
                ? `${plan.included_users} Users`
                : "- Users";
              features.splice(1, 0, usersCount);
            }

            let yearlyPrice =
              planType === "team" &&
              isPro &&
              plan?.slabs?.length > 0 &&
              plan.slabs[0]?.rate_annual
                ? (
                    parseFloat(plan.slabs[0].rate_annual) * plan.slabs[0].count
                  ).toFixed(2)
                : plan?.yearly_price || "0.00";

            return {
              plan: plan?.name?.replace(" User", "") || "N/A",
              isBest: isPro,
              monthlyPrice: plan?.monthly_price || "0.00",
              yearlyPrice: yearlyPrice,
              billing:
                plan?.name === targetElite
                  ? "Annual billing only"
                  : "per user/month",
              description: isPro
                ? "For scaling businesses"
                : "For Large Organizations",
              features: features,
              buttonText: isPro ? "Get Started" : "Request Trial",
              buttonLink: isPro
                ? "https://app.simplifyte.com/login"
                : "/contactsales",
            };
          });
          setPlanData(formattedPlans);
        } else {
          setPlanData([]);
        }
        setLoading(false);
        setTabLoading(false);
      })
      .catch((err) => {
        setError("Failed to fetch plans");
        setPlanData([]);
        setLoading(false);
        setTabLoading(false);
      });
  }, [planType]);

  return (
    <div className="grid lg:grid-cols-12 grid-cols-1 gap-[30px]">
      <div className="lg:col-span-5">
        <div className="lg:text-start text-center">
          <h3 className=" SetUp-Class">
            From Setup <br /> to Success
          </h3>
          <p className="Setup-Class-paragraph">
            Streamline your workflow and accelerate growth with Simplifyte.
          </p>

          <div className="mt-6">
            <ul className="inline-block w-fit mx-auto flex-wrap justify-center text-center p-2 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-full">
              {/* <li role="presentation" className="tab-btn inline-block">
                <button
                  onClick={() => handlePlanTypeChange("user")}
                  className={`${
                    planType === "user"
                      ? "text-white bg-indigo-600 hover:text-white"
                      : ""
                  } px-4 py-1 text-sm font-semibold rounded-full w-full transition-all duration-500 ease-in-out`}
                >
                  <FontAwesomeIcon
                    icon={faUser}
                    className="sub-header-career mr-2"
                  />
                  Per User Plans
                </button>
              </li>
              <li role="presentation" className="tab-btn inline-block">
                <button
                  onClick={() => handlePlanTypeChange("team")}
                  className={`${
                    planType === "team"
                      ? "text-white bg-indigo-600 hover:text-white"
                      : ""
                  } px-4 py-1 text-sm font-semibold rounded-full w-full transition-all duration-500 ease-in-out`}
                >
                  <FontAwesomeIcon
                    icon={faUsers}
                    className="sub-header-career mr-2"
                  />
                  Team Plans
                </button>
              </li> */}
              <li role="presentation" className="tab-btn inline-block">
                <button
                  onClick={() => HandleTabClick(0)}
                  className={`${
                    opentab === 0
                      ? "text-white bg-indigo-600 hover:text-white"
                      : ""
                  } px-4 py-1 text-sm font-semibold rounded-full w-full transition-all duration-500 ease-in-out`}
                >
                  <FontAwesomeIcon
                    icon={faUser}
                    className="sub-header-career mr-2"
                  />
                  Per User Plans
                </button>
              </li>
              <li role="presentation" className="tab-btn inline-block">
                <button
                  onClick={() => HandleTabClick(1)}
                  className={`${
                    opentab === 1
                      ? "text-white bg-indigo-600 hover:text-white"
                      : ""
                  } px-4 py-1 text-sm font-semibold rounded-full w-full transition-all duration-500 ease-in-out`}
                >
                  <FontAwesomeIcon
                    icon={faUsers}
                    className="sub-header-career mr-2"
                  />
                  Team Plans
                </button>
              </li>
            </ul>
          </div>
          <div className="mt-4">
            <Link
              to="/pricing"
              className="relative inline-flex items-center font-semibold tracking-wide align-middle text-base text-center border-none after:content-[''] after:absolute after:h-px after:w-0 hover:after:w-full after:end-0 hover:after:end-auto after:bottom-0 after:start-0 after:duration-500 text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500"
            >
              Find Out More
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 24 24"
                className="text-xl ms-1"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path fill="none" d="M0 0h24v24H0V0z"></path>
                <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
              </svg>
            </Link>
          </div>
        </div>
      </div>
      <div className="lg:col-span-7 mt-8 lg:mt-0">
        <div className="grid lg:grid-cols-2 md:grid-cols-2 gap-[30px] ">
          {loading || tabLoading ? (
            Array(2)
              .fill(null)
              .map((_, i) => (
                <div
                  key={i}
                  className="p-6 py-8 rounded-xl shadow dark:shadow-gray-800 bg-white bg-slate-200 animate-pulse"
                >
                  <div className="h-3 w-16 bg-slate-200 bg-slate-200 rounded mb-5" />
                  <div className="h-8 w-28 bg-slate-200 bg-slate-200 rounded mb-4" />
                  <div className="flex items-center gap-3 mb-5">
                    <div className="h-5 w-10 bg-slate-200 bg-slate-200 rounded-full" />
                    <div className="h-3 w-20 bg-slate-200 bg-slate-200 rounded" />
                  </div>
                  {[100, 80, 90, 70, 85].map((w, j) => (
                    <div
                      key={j}
                      className={`h-3 w-[${w}%] bg-slate-200 bg-slate-200 rounded mb-2`}
                    />
                  ))}
                  <div className="h-9 w-28 bg-slate-200 bg-slate-200 rounded-xl mt-6" />
                </div>
              ))
          ) : error ? (
            <div>Error: {error}</div>
          ) : planData.length > 0 ? (
            planData.map((plan, index) => {
              let displayPrice = isMonthly
                ? plan.monthlyPrice
                : plan.yearlyPrice;
              let billingText = plan.billing;

              if (plan.plan === "Pro") {
                if (planType === "user") {
                  if (!isMonthly) {
                    displayPrice = plan.yearlyPrice;
                  }
                } else {
                  displayPrice = plan.yearlyPrice;
                  // user change to team that code and that price
                  // console.log("year again and again", displayPrice);
                  billingText = "p.a.";
                }
              }

              // Check conditions for Elite plan
              const showSwitchMessage =
                plan.plan === "Elite" && planType === "user" && isMonthly;
              const showYearlyPrice =
                plan.plan === "Elite" && planType === "user" && !isMonthly;
              const isEliteTeam = plan.plan === "Elite" && planType === "team";
              // Inside your map function, before returning the card:
              const currentServicesData =
                opentab === 0 ? userServicesData : teamServicesData;
              const currentService = currentServicesData[index];
              return (
                <div
                  key={index}
                  className={`group border-b-[3px] ${
                    plan.isBest
                      ? "hover:border-indigo-600"
                      : "hover:border-indigo-600"
                  } p-6 py-8 transition-all duration-500 overflow-hidden ease-in-out hover:scale-105 relative shadow dark:shadow-gray-800 rounded-xl ${
                    plan.isBest
                      ? "bg-white dark:bg-slate-900"
                      : "hover:bg-white dark:hover:bg-slate-900"
                  } h-fit`}
                >
                  {plan.isBest && (
                    <span className="absolute -end-11 -top-[10px] ltr:rotate-[45deg] rtl:-rotate-[45deg] w-32 h-16 pt-4 px-2 pb-0 flex items-center justify-center text-white bg-amber-500 font-semibold text-lg">
                      Best
                    </span>
                  )}
                  <h6 className="font-bold uppercase mb-3 text-indigo-600">
                    {plan.plan}
                  </h6>

                  <div className="flex mb-3 price-label">
                    {plan.plan === "Pro" ? (
                      <>
                        <div className="flex items-center gap-2">
                          {!isMonthly && planType === "user" ? (
                            // Show strikethrough original price and new price for yearly
                            <>
                              <AnimatePresence mode="popLayout">
                                <motion.span
                                  key={`strike-${displayPrice}`}
                                  className="price text-base font-normal mb-0 line-through text-gray-400"
                                  initial={{ opacity: 0, y: -10 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  exit={{ opacity: 0, y: 10 }}
                                  transition={{ duration: 0.3 }}
                                >
                                  <span className="text-sm font-semibold price-line-not">
                                    ₹
                                  </span>
                                  {parseFloat(plan.monthlyPrice).toLocaleString(
                                    "en-IN",
                                    {
                                      maximumFractionDigits: 0,
                                    },
                                  )}
                                </motion.span>
                              </AnimatePresence>

                              <AnimatePresence mode="popLayout">
                                <motion.span
                                  key={`price-${displayPrice}`}
                                  className="price text-3xl font-semibold mb-0 text-indigo-600"
                                  initial={{ opacity: 0, y: -10 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  exit={{ opacity: 0, y: 10 }}
                                  transition={{ duration: 0.3 }}
                                >
                                  <span className="text-xl font-semibold text-[#161c2d]">
                                    ₹
                                  </span>

                                  {/* this is old code that is not divided by 12 */}
                                  {/* {parseFloat(displayPrice).toLocaleString(
                                    "en-IN",
                                    {
                                      maximumFractionDigits: 0,
                                    },
                                  )} */}
                                  {/* This is divided by 12 */}
                                  {(
                                    parseFloat(displayPrice) / 12
                                  ).toLocaleString("en-IN", {
                                    maximumFractionDigits: 0,
                                  })}
                                </motion.span>
                              </AnimatePresence>
                            </>
                          ) : (
                            // Show single price for monthly
                            <AnimatePresence mode="popLayout">
                              <motion.span
                                key={displayPrice}
                                className="price text-3xl font-semibold mb-0"
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 10 }}
                                transition={{ duration: 0.3 }}
                              >
                                <span className="text-xl font-semibold text-[#161c2d]">
                                  ₹
                                </span>
                                {parseFloat(displayPrice).toLocaleString(
                                  "en-IN",
                                  {
                                    maximumFractionDigits: 0,
                                  },
                                )}
                              </motion.span>
                            </AnimatePresence>
                          )}
                        </div>
                        <span className="text-sm color_class font-semibold self-end mb-1 ml-1">
                          {billingText}
                        </span>
                      </>
                    ) : (
                      <div>
                        {showSwitchMessage ? (
                          // User mode + Elite + Monthly - Show switch message only
                          <div className="flex flex-col gap-5">
                            <AnimatePresence mode="popLayout">
                              <motion.div
                                key="switch-message"
                                className="text-[18px] font-semibold text-gray-800"
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 10 }}
                                transition={{ duration: 0.3 }}
                              >
                                <button
                                  className="relative inline-flex items-center font-semibold tracking-wide
                                 align-middle text-base text-center border-none after:content-['']
                                  after:absolute after:h-px after:w-0 hover:after:w-full after:end-0
                                   hover:after:end-auto after:bottom-0 after:start-0 after:duration-500 
                                   text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500"
                                  onClick={() => setIsMonthly((prev) => !prev)}
                                >
                                  View yearly pricing
                                </button>
                              </motion.div>
                            </AnimatePresence>
                            <motion.div
                              className="text-base text-[#093A5B] font-semibold"
                              initial={{ opacity: 0, y: 8 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: -8 }}
                              transition={{
                                duration: 0.3,
                                ease: "easeInOut",
                              }}
                            >
                              Billed Yearly
                            </motion.div>
                          </div>
                        ) : showYearlyPrice ? (
                          // User mode + Elite + Yearly - Show price
                          <>
                            <span className="text-xl font-semibold">₹</span>
                            <AnimatePresence mode="popLayout">
                              <motion.span
                                key={displayPrice}
                                className="price text-3xl font-semibold mb-0"
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 10 }}
                                transition={{ duration: 0.3 }}
                              >
                                {/* {parseFloat(displayPrice).toLocaleString(
                                  "en-IN",
                                  {
                                    maximumFractionDigits: 0,
                                  },
                                )} */}
                                {(parseFloat(displayPrice) / 12).toLocaleString(
                                  "en-IN",
                                  { maximumFractionDigits: 0 },
                                )}
                              </motion.span>
                            </AnimatePresence>

                            <AnimatePresence mode="wait">
                              <motion.span
                                key="billing"
                                className="text-[14px] color_class font-semibold mb-1 ml-1 inline-block"
                                initial={{ opacity: 0, x: -10 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 10 }}
                                transition={{ duration: 0.25 }}
                              >
                                per user/month
                              </motion.span>
                            </AnimatePresence>

                            <AnimatePresence mode="wait">
                              <motion.div
                                // key="yearly-text"
                                key={isMonthly ? "monthly-text" : "yearly-text"}
                                className="text-base text-[#093A5B] mt-3 font-semibold"
                                initial={{ opacity: 0, y: 8 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -8 }}
                                transition={{
                                  duration: 0.3,
                                  ease: "easeInOut",
                                }}
                              >
                                Billed Yearly
                              </motion.div>
                            </AnimatePresence>
                          </>
                        ) : isEliteTeam ? (
                          // Team mode + Elite - Show Custom Pricing
                          <>
                            <AnimatePresence mode="popLayout">
                              <div className="inline-flex flex-col gap-4">
                                <motion.span
                                  key="custom-pricing"
                                  className="price text-[24px] font-semibold mb-0"
                                  initial={{ opacity: 0, y: -10 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  exit={{ opacity: 0, y: 10 }}
                                  transition={{ duration: 0.3 }}
                                >
                                  Custom Pricing
                                </motion.span>
                                <span
                                  style={{
                                    fontSize: "16px",
                                    color: "#093a5b",
                                    fontWeight: "600",
                                    marginTop: "4px",
                                  }}
                                >
                                  {/* Elite Card of Pricing Page both card */}
                                  Billed Yearly
                                </span>
                              </div>
                            </AnimatePresence>

                            {/* <div className="text-sm text-gray-500 mt-1">
                              Billed Annually
                            </div> */}
                          </>
                        ) : (
                          // ❌ ONLY for non-Elite-Team
                          <>
                            <span className="text-xl font-semibold">₹</span>
                            <AnimatePresence mode="popLayout">
                              <motion.span
                                key={displayPrice}
                                className="price text-[24px] font-semibold mb-0"
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 10 }}
                                transition={{ duration: 0.3 }}
                              >
                                {parseFloat(displayPrice).toLocaleString(
                                  "en-IN",
                                  {
                                    maximumFractionDigits: 0,
                                  },
                                )}
                              </motion.span>
                            </AnimatePresence>
                          </>
                        )}
                      </div>
                    )}
                  </div>

                  {/* <div className="pricing-inner-title mb-5">
                    {plan.plan === "Pro" ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "15px",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: planType === "user" ? "pointer" : "not-allowed",
                            position: "relative",
                            width: "40px",
                            height: "22px",
                            backgroundColor:
                              planType === "user"
                                ? isMonthly
                                  ? "#a6a8aa"
                                  : "#093a5b"
                                : "#d3d3d3",
                            borderRadius: "15px",
                            opacity: planType === "user" ? 1 : 0.5,
                          }}
                          onClick={handleToggle}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: "-1px",
                              left: "5px",
                              transform: isMonthly && planType === "user"
                                ? "translateX(0)"
                                : "translateX(17px)",
                              transition:
                                "transform 0.4s cubic-bezier(.16,1,.3,1)",
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faCircle}
                              style={{ fontSize: "15px", color: "#f4f4f4" }}
                            />
                          </div>
                        </div>
                        {planType === "user" ? (
                          <span
                            style={{
                              display: "block",
                              fontSize: "15px",
                              fontWeight: "600",
                              color: isMonthly ? "#a6a8aa" : "#093a5b",
                            }}
                          >
                            Billed yearly
                          </span>
                        ) : (
                          <span
                            style={{
                              fontSize: "15px",
                              color: "#093a5b",
                              fontWeight: "600",
                            }}
                          >
                            Yearly Only
                          </span>
                        )}
                      </div>
                    ) : (
                      <div className="pricing-inner-title mb-5">
                        <span>Annual billing only</span>
                      </div>
                    )}
                  </div> */}
                  <div className="pricing-inner-title mb-5">
                    {plan.plan === "Pro" ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "15px",
                          alignItems: "center",
                        }}
                      >
                        {/* Toggle (only for User mode) */}
                        {planType === "user" && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              position: "relative",
                              width: "40px",
                              height: "22px",
                              backgroundColor: isMonthly
                                ? "#a6a8aa"
                                : "#093a5b",
                              borderRadius: "15px",
                            }}
                            onClick={handleToggle}
                          >
                            <div
                              style={{
                                position: "absolute",
                                top: "-1px",
                                left: "5px",
                                transform: isMonthly
                                  ? "translateX(0)"
                                  : "translateX(17px)",
                                transition:
                                  "transform 0.4s cubic-bezier(.16,1,.3,1)",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faCircle}
                                style={{ fontSize: "15px", color: "#f4f4f4" }}
                              />
                            </div>
                          </div>
                        )}
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color:
                              planType === "team"
                                ? "#093a5b"
                                : isMonthly
                                  ? "#a6a8aa"
                                  : "#093a5b",
                          }}
                        >
                          {planType === "team"
                            ? "Yearly Only"
                            : "Billed Yearly"}
                        </span>
                      </div>
                    ) : (
                      // Elite plan – no toggle, just static text
                      <div>
                        <span
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            color: "#093a5b",
                          }}
                        >
                          {/* {planType === "team" ? "Custom Pricing (Annual)" : ""} */}
                        </span>
                      </div>
                    )}
                  </div>
                  {/* <ul
                    className="list-none text-slate-400 minimum-height-ul max-h-[260px] overflow-auto"
                    style={{ scrollbarWidth: "none" }}
                  >
                    <li className="mb-2 flex items-center ms-0">
                      {plan.description}
                    </li>
                    {plan.features.map((feature, idx) => (
                      <li key={idx} className="mb-2 flex items-center ms-0">
                        <span>
                          <BsCheckCircle className="text-indigo-600 text-base me-2" />
                        </span>
                        {feature}
                      </li>
                    ))}
                  </ul> */}
                  <ul
                    className="list-none text-slate-400 minimum-height-ul max-h-[260px] overflow-auto"
                    style={{ scrollbarWidth: "none" }}
                  >
                    <li className="mb-2 flex items-center ms-0">
                      {plan.description}
                    </li>
                    {/* {console.log("Opentab", opentab)} like 0 and 1*/}
                    {/* Show user count for team plans */}
                    {opentab === 1 &&
                      currentService &&
                      currentService.userCount && (
                        <li className="mb-1 flex items-center gap-2 font-semibold text-gray-700 ms-0">
                          <BsCheckCircle className="text-indigo-600 flex-shrink-0" />
                          <span>{currentService.userCount}</span>
                        </li>
                      )}
                    {/* Show features from dummy data */}
                    {currentService && (
                      <>
                        <div className="flex items-center gap-2 mb-2">
                          <BsCheckCircle className="text-indigo-600 flex-shrink-0" />
                          <div className="flex gap-1">
                            <span className="gen">{currentService.title1}</span>
                            <span className="gen para_title">
                              {currentService.para}
                            </span>
                          </div>
                        </div>
                        <div className="flex items-center gap-2 mb-2">
                          <BsCheckCircle className="text-indigo-600 flex-shrink-0" />
                          <span className="gen">{currentService.title2}</span>
                        </div>
                        <div className="flex items-center gap-2 mb-2">
                          <BsCheckCircle className="text-indigo-600 flex-shrink-0" />
                          <span className="gen">{currentService.title3}</span>
                        </div>
                        <div className="flex items-center gap-2 mb-2">
                          <BsCheckCircle className="text-indigo-600 flex-shrink-0" />
                          <span className="gen">{currentService.title4}</span>
                        </div>
                      </>
                    )}
                  </ul>
                  <Link
                    className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-xl mt-5"
                    to={plan.buttonLink}
                  >
                    {plan.buttonText}
                  </Link>
                </div>
              );
            })
          ) : (
            <div>No plans available</div>
          )}
        </div>
      </div>
    </div>
  );
}
